var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72946 0 0.000152707 6.63965 0.000152707 14.7907C-0.0542217 26.714 14.43 36.6004 15 37C15 37 30.0542 26.714 29.9999 14.8C29.9999 6.63965 23.2705 0 15 0ZM15 22.2C10.8563 22.2 7.50008 18.8885 7.50008 14.8C7.50008 10.7115 10.8563 7.4 15 7.4C19.1437 7.4 22.4999 10.7115 22.4999 14.8C22.4999 18.8885 19.1437 22.2 15 22.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.06baeee503e435c994a8719978aca1c0.svg";
export { ForwardRef as ReactComponent };